"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIGH = 'high';
exports.LOW = 'low';
exports.MEDIUM = 'mid';
exports.SEVERE = 'severe';
exports.MEMO_PRIORITIES = [exports.LOW, exports.MEDIUM, exports.HIGH, exports.SEVERE];
//# sourceMappingURL=memo-priorities.js.map